
export default function changelogsHelpGeneralPerformance(labels, sumData, uniqueData) {
    return {
        chart: {
            height: 160 + (labels.length * 30),
            type: 'bar',
            fontFamily: 'Nunito',
            toolbar: { show: false },
            zoom: {
                enabled: false
            }
        },
        //colors: ['#00e396', '#E91E63', '#F44336', '#9C27B0'],
        colors: ["#006AA9"],
        plotOptions: {
            bar: {
                horizontal: true,
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return val;
            },
            offsetY: 0,
            offsetX: -10,
            style: {
                fontSize: '12px',
                colors: ["#ffffff", "#ffffff"]
            }
        },
        series: [/*{
            name: 'Views',
            data: sumData
        },*/
        {
            name: 'Unique views',
            data: uniqueData
        }],
        xaxis: {
            categories: labels,
            position: 'bottom',
            labels: {
                offsetY: 0,
            },
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            },
            tooltip: {
                enabled: false,
                offsetY: -35,

            }
        },
        fill: {
            gradient: {
                shade: 'light',
                type: "horizontal",
                shadeIntensity: 0.25,
                gradientToColors: undefined,
                inverseColors: true,
                opacityFrom: 0.1,
                opacityTo: 1,
                stops: [50, 0, 100, 100]
            },
        },
        yaxis: {
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false,
            },
            forceNiceScale: true,
            labels: {
                show: true,
                //formatter: function (val, index) {
                //    return val.toFixed(0);
                //}
            }
        }
    };
}